/**
 * The sortable container of a Sales Album's Guide Layout. The album id itself stays the container
 * of the Backlog, so photos dragged into other albums keep their source album id.
 */
export const buildPhotoGuideLayoutContainerId = (saleVehicleAlbumId: string) =>
  `${saleVehicleAlbumId}:photo-guide-layout`;
